var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47.592,
    height: 62.146,
    viewBox: "0 0 47.592 62.146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1, 1) translate(-47.592, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M1.74254 27.9389C-0.580846 29.6723 -0.580846 32.4873 1.74254 34.2207C1.74254 34.2207 37.4297 60.8457 37.4297 60.8457C39.7531 62.5791 43.5263 62.5791 45.8497 60.8457C48.1731 59.1123 48.1731 56.2973 45.8497 54.5639C45.8497 54.5639 14.3632 31.0729 14.3632 31.0729C14.3632 31.0729 45.8311 7.58188 45.8311 7.58188C48.1545 5.84848 48.1545 3.03345 45.8311 1.30005C43.5077 -0.433349 39.7345 -0.433349 37.4111 1.30005C37.4111 1.30005 1.72395 27.925 1.72395 27.925C1.72395 27.925 1.74254 27.9389 1.74254 27.9389Z",
    fill: "#637F6C",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextBtn);
export default __webpack_public_path__ + "static/media/nextBtn.16b74f9fd60f1095bfcfd6589e067f8f.svg";
export { ForwardRef as ReactComponent };